var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	30977: {
		fallback: () => (() => (__webpack_require__(98481))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.9.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	50022: {
		fallback: () => (() => (__webpack_require__(98481))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	88066: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	97923: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	1713: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	42848: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.9.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	68079: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.11.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	54163: {
		fallback: () => (() => (__webpack_require__(71763))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [30977,50022,88066,97923,1713,42848];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"550": [
		68079,
		54163
	],
	"792": [
		30977,
		50022,
		88066,
		97923,
		1713,
		42848
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}